import { render } from "./TheSidebar.vue?vue&type=template&id=696fae28&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"

import "../css/adminlte.css?vue&type=style&index=0&id=696fae28&lang=css&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696fae28"]])

export default __exports__